import React, { useContext } from 'react'
import ResinousSystemTypeList from './ResinousSystemTypeList'
import AppNavigation from '../../AppNavigation'
import Loading from '../../loading'
import { AppContext } from '../../../App'

export default function ResinousSystemTypeSelection() {
   const { productOptionsSelected, loading } = useContext(AppContext)
   const { productOptions } = productOptionsSelected
   const system = productOptions[2]
   const productDetail = (`resinous ${ system } system types`).toLowerCase()
   
   return (
      loading ? (
      // If loading, show loader.
      <Loading type={ productDetail } />
      ) : (
         <React.Fragment>
               <div className="col-xs-12 col-md-9 col-md-push-3">
                  <ResinousSystemTypeList />
               </div>
               <AppNavigation />
         </React.Fragment>
         )
   )
}


// WEBPACK FOOTER //
// ./src/components/productTypes/resinous/ResinousSystemTypeSelection.js